import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleDownMedium: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-triangle-down-medium, dropdown, caret"><path d="M15.1046 9C16.5912 9.00037 17.4007 10.7375 16.4444 11.876L13.3399 15.5713C12.6406 16.4033 11.3595 16.4034 10.6603 15.5713L7.55576 11.876C6.59967 10.7376 7.40916 9.00054 8.89561 9H15.1046Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronTriangleDownMedium;
